import React, { useEffect, useState } from "react";
import StudentProgress from "../../../Api/StudentProgress";

const Dashborad = () => {
    const [progressData, setProgressData] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchProgress = async () => {
            try {
                const response = await new StudentProgress().GetStudentProgress();
                if (response?.data?.status === "success") {
                    setProgressData(response.data.data);
                } else {
                    setError("Failed to fetch progress data");
                }
            } catch (error) {
                console.error("Error fetching progress:", error);
                setError("Error loading progress data");
            } finally {
                setLoading(false);
            }
        };

        fetchProgress();
    }, []);

    // Calculate statistics
    const totalEnrolled = progressData?.length || 0;
    const activeCourses = progressData?.filter(course => !course.is_completed).length || 0;
    const completedCourses = progressData?.filter(course => course.is_completed).length || 0;

    if (loading) {
        return (
            <div className="content">
                <div className="section-title">
                    <h4 className="rbt-title-style-3">Loading...</h4>
                </div>
            </div>
        );
    }

    if (error) {
        return (
            <div className="content">
                <div className="section-title">
                    <h4 className="rbt-title-style-3 text-danger">{error}</h4>
                </div>
            </div>
        );
    }

    return (
        <>
            <div className="content">
                <div className="section-title">
                    <h4 className="rbt-title-style-3">Dashboard</h4>
                </div>
                <div className="row g-5">
                    {/* Start Single Card  */}
                    <div className="col-lg-4 col-md-4 col-sm-6 col-12">
                        <div className="rbt-counterup variation-01 rbt-hover-03 rbt-border-dashed bg-primary-opacity">
                            <div className="inner">
                                <div className="rbt-round-icon bg-primary-opacity">
                                    <i className="feather-book-open" />
                                </div>
                                <div className="content">
                                    <h3 className="counter without-icon color-primary">
                                        <span className="odometer" data-count={totalEnrolled}>
                                            {totalEnrolled}
                                        </span>
                                    </h3>
                                    <span className="rbt-title-style-2 d-block">
                                        Enrolled
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                    {/* End Single Card  */}
                    {/* Start Single Card  */}
                    <div className="col-lg-4 col-md-4 col-sm-6 col-12">
                        <div className="rbt-counterup variation-01 rbt-hover-03 rbt-border-dashed bg-secondary-opacity">
                            <div className="inner">
                                <div className="rbt-round-icon bg-secondary-opacity">
                                    <i className="feather-monitor" />
                                </div>
                                <div className="content">
                                    <h3 className="counter without-icon color-secondary">
                                        <span className="odometer" data-count={activeCourses}>
                                            {activeCourses}
                                        </span>
                                    </h3>
                                    <span className="rbt-title-style-2 d-block">
                                        ACTIVE
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                    {/* End Single Card  */}
                    {/* Start Single Card  */}
                    <div className="col-lg-4 col-md-4 col-sm-6 col-12">
                        <div className="rbt-counterup variation-01 rbt-hover-03 rbt-border-dashed bg-violet-opacity">
                            <div className="inner">
                                <div className="rbt-round-icon bg-violet-opacity">
                                    <i className="feather-award" />
                                </div>
                                <div className="content">
                                    <h3 className="counter without-icon color-violet">
                                        <span className="odometer" data-count={completedCourses}>
                                            {completedCourses}
                                        </span>
                                    </h3>
                                    <span className="rbt-title-style-2 d-block">
                                        Completed
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                    {/* End Single Card  */}
                </div>
            </div>
        </>
    );
};

export default Dashborad;
